import { Link } from "react-router-dom";
import { isValidArray } from "../../Layout/Common/common";
import { PAGES } from "../../routeConfig";
import { AutosuggestPopupItemSkeleton } from "../../Skeleton/autoSuggestPopup/autosuggestPopupItemSkeleton";
import { CategorySuggestion } from "./categorySuggestion";
import { ItemContainer } from "./itemContainer";
import { QuerySuggestion } from "./querySuggestion";
import { Fragment, useEffect, useState } from "react";
import { getUniqueFamiliesByLowestPrice } from "../../Layout/Common/algoliaInstantLib";

export const AutoCompleteResult = ({ hits, suggestions, query }) => {
  const [groupHits, setGroupHits] = useState(null);
  useEffect(() => {
    setGroupHits(null);

    if (hits) {
      setGroupHits(hits.slice(0, 12));
    } else setGroupHits([]);
  }, [hits, query]);

  return (
    <div className="row tag-products m-0">
      <div className="col-lg-3 search-tags-lft">
        <div className="search-tags bg-transparent">
          <div className="search-tags-details">
            <QuerySuggestion suggestions={suggestions ?? []} isOpen={true} />
            <CategorySuggestion suggestions={suggestions} isOpen={true} />
          </div>
        </div>
      </div>
      <div className="col-lg-9 search-tags-rht">
        <div className="search-products bg-transparent">
          <div className="search-tags-title">
            <h5>Product Suggestions</h5>
          </div>
          <div className="search-suggestion-list">
            <div className="search-carousel">
              <div className="row">
                {isValidArray(groupHits) ? (
                  groupHits.map((item, idx) => <ItemContainer item={item} key={idx} />)
                ) : !groupHits ? (
                  <Fragment>
                    {Array.from({ length: 6 }).map((_, i) => (
                      <AutosuggestPopupItemSkeleton index={i} key={i} />
                    ))}
                  </Fragment>
                ) : (
                  query && <div className="order-dec pre-order-status mt-2">No Results Found</div>
                )}
              </div>
              {query && isValidArray(groupHits) && (
                <div className="row">
                  <div className="col-lg-12">
                    <Link to={PAGES.SEARCH + "?q=" + encodeURIComponent(query)} className="d-block py-2 view-results">
                      View All Results
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
